module.exports = __webpack_public_path__ + "img/collection-memoireRingsSlim@2x.7a96423.webp";